import request from '@/utils/request'

export function getList() {
    return request({
        url: '/shop/log/tem/getList',
        method: 'get',
    })
}

export function info(id) {
    return request({
        url: '/shop/log/tem/info/' + id,
        method: 'get'
    })
}

export function savaOrUpdate(status) {
    return request({
        url: '/shop/log/tem/savaOrUpdate/' + status,
        method: 'get'
    })
}

export function save(shopLogTem,shopLogRules,shopLogStatus) {
    let data = {shopLogTem,shopLogRules,shopLogStatus};
    data.json=true
    return request({
        url: '/shop/log/tem/save',
        method: 'post',
        data
    })
}
export function update(shopLogTem,shopLogRules,shopLogStatus) {
    let data = {shopLogTem,shopLogRules,shopLogStatus};
    data.json=true
    return request({
        url: '/shop/log/tem/update',
        method: 'post',
        data
    })
}
export function remove(data) {
    return request({
        url: '/shop/log/tem/delete',
        method: 'post',
        data
    })
}
export function getLogRuleList() {
    return request({
        url: '/shop/log/tem/getLogRuleList',
        method: 'post',
    })
}
